import { BaseDataService } from "../../../services/base/BaseDataService";
import { StandartSolution } from "../models/StandartSolution";
import { StandartSolutionQuery } from "../models/StandartSolutionQuery";

export class StandartSolutionService extends BaseDataService<StandartSolution, StandartSolutionQuery> {
  protected prefixUrl = `StandartSolutions`;

  downloadAll(folderId: number) {
    return this.downloadFile(`${this.prefixUrl}/DownloadAll?folderId=${folderId}`);
  }
}
